import { IOrdersDashboardSummaryQuery } from 'dto/orders.dto'

/**
 * Собирает query-параметры для GET /orders/dashboard-summary.
 * @param query — фильтры с главной
 * @returns строка `?a=1&b=2` или пустая строка
 */
export const buildOrdersDashboardSummaryParams = (
  query?: IOrdersDashboardSummaryQuery,
): string => {
  if (!query) {
    return ''
  }

  const searchParams = new URLSearchParams()

  if (
    typeof query.pizzeria_id === 'number' &&
    !Number.isNaN(query.pizzeria_id)
  ) {
    searchParams.set('pizzeria_id', String(query.pizzeria_id))
  }
  if (typeof query.status_id === 'number' && !Number.isNaN(query.status_id)) {
    searchParams.set('status_id', String(query.status_id))
  }
  if (query.payment_type?.trim?.()) {
    searchParams.set('payment_type', query.payment_type.trim())
  }
  if (query.payment_status?.trim?.()) {
    searchParams.set('payment_status', query.payment_status.trim())
  }

  const queryString = searchParams.toString()
  return queryString ? `?${queryString}` : ''
}
